import { Box, Skeleton, Stack } from "@mui/material";
import { Card } from "@src/appV2/redesign/system/ui-components";

import { CARD_ACTIONS_BUTTON_HEIGHT_PX, PILLS_HEIGHT_PX } from "../../../Chat/constants";
import { PayInfoLabel } from "../../Pay/PayInfoLabel";
import { ShiftCardDivider } from "../../Shift/Card/CardDivider";
import { BookingCardContentWrapper } from "../../Shift/CardContentWrapper";
import { ShiftCardPillsWrapper } from "../../Shift/PillsWrapper";
import { ShiftQualificationLabel } from "../../Shift/QualificationLabel";
import { BookingCardSummaryWrapper } from "../../Shift/SummaryWrapper";

interface ShiftInviteCardSkeletonProps {
  isCardActionable: boolean;
}

export function ShiftInviteCardSkeleton(props: ShiftInviteCardSkeletonProps) {
  const { isCardActionable } = props;
  return (
    <Card outlined aria-label="Shift invite card skeleton" sx={{ width: "100%" }}>
      <BookingCardContentWrapper sx={{ gap: 1 }}>
        <BookingCardSummaryWrapper sx={{ justifyContent: "space-between" }}>
          <ShiftCardPillsWrapper sx={{ width: "100%" }}>
            <Skeleton variant="rounded" width="20%" height={PILLS_HEIGHT_PX} />
            <Skeleton variant="rounded" width="30%" height={PILLS_HEIGHT_PX} />
          </ShiftCardPillsWrapper>

          <PayInfoLabel isLoading totalPay="0" hourlyPay="0" />
        </BookingCardSummaryWrapper>

        {/* ShiftCardSummaryInfo */}
        <Stack gap={1}>
          <Skeleton
            variant="text"
            width="30%"
            sx={(theme) => ({ height: theme.typography.body2.fontSize })}
          />
          <Skeleton
            variant="text"
            width="60%"
            sx={(theme) => ({ height: theme.typography.body1.fontSize })}
          />
          <Skeleton
            variant="text"
            width="40%"
            sx={(theme) => ({ height: theme.typography.body2.fontSize })}
          />
        </Stack>

        <Box sx={{ marginTop: 3 }}>
          <ShiftQualificationLabel isLoading qualificationText="" />
        </Box>

        {isCardActionable && (
          <>
            <ShiftCardDivider />
            <Stack direction="row" justifyContent="space-between" width="100%" gap={3}>
              <Skeleton variant="rounded" width="100%" height={CARD_ACTIONS_BUTTON_HEIGHT_PX} />
              <Skeleton variant="rounded" width="100%" height={CARD_ACTIONS_BUTTON_HEIGHT_PX} />
            </Stack>
          </>
        )}
      </BookingCardContentWrapper>
    </Card>
  );
}
